import { Skeleton } from 'antd';

import { DOCUMENT_TYPE } from 'api/documents/documents.model';
import CardRow from 'components/CardRow';
import GoToCertificateButton from 'components/GoToCertificateButton';
import { useCertificatesQuery } from 'hooks/useCertificatesQuery';

import EmptyState from '../../EmptyState';
import CertificateDetails from '../CertificateDetails';
import DetailsCard from '../DetailsCard';
import * as Styled from './Certificate.styles';

interface CertificateProps {
  productId: string;
  batteryPackSerialNumber?: string;
}

const Certificate = ({ productId, batteryPackSerialNumber }: CertificateProps) => {
  const { data: certificatesData, isLoading: isCertificatesDataLoading } = useCertificatesQuery({
    productId,
    documentType: DOCUMENT_TYPE.PUBLIC,
  });
  const { data: additionalCertificatesData, isLoading: isAdditionalCertificatesDataLoading } =
    useCertificatesQuery(
      {
        batteryPackSerialNumber,
        documentType: DOCUMENT_TYPE.PUBLIC,
      },
      {
        enabled: !!batteryPackSerialNumber,
      }
    );

  if (isCertificatesDataLoading || isAdditionalCertificatesDataLoading) {
    return <Skeleton active />;
  }

  return (
    <EmptyState visible={!certificatesData}>
      <>
        {batteryPackSerialNumber ? (
          <Styled.DetailsCardContainer>
            {certificatesData?.rows?.map((document) => (
              <DetailsCard key={document.jobId} {...document} />
            ))}
            {additionalCertificatesData?.rows?.map((document) => (
              <DetailsCard key={document.jobId} {...document} />
            ))}
          </Styled.DetailsCardContainer>
        ) : (
          certificatesData?.rows?.map((document) => (
            <CardRow key={document.jobId}>
              <CertificateDetails {...document} />
              <GoToCertificateButton
                documentBlockchainAddress={document.documentBlockchainAddress}
              />
            </CardRow>
          ))
        )}
      </>
    </EmptyState>
  );
};

export default Certificate;
